(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("shoppingCartResource", ["$resource", shoppingCartResource]);
    function shoppingCartResource($resource) {
        return $resource("/api/shopping-cart/:action", { action: "@action" }, {
            synchronize: {
                method: "POST",
                params: {
                    action: "synchronize"
                }
            },
            addToMyShoppingCart: {
                method: "POST",
                params: {
                    action: "add"
                }
            },
            removeFromMyShoppingCart: {
                method: "POST",
                params: {
                    action: "remove"
                }
            },
            clear: {
                method: "POST",
                params: {
                    action: "clear"
                }
            },
            applyDiscount: {
                method: "POST",
                params: {
                    action: "apply-discount"
                }
            },
            removeDiscount: {
                method: "POST",
                params: {
                    action: "remove-discount"
                }
            },
            getCrossSell: {
                method: "GET",
                params: {
                    action: "cross-sell"
                }
            }
        });
    }
}());
